import { render, staticRenderFns } from "./index.vue?vue&type=template&id=db400fb2&scoped=true&"
import script from "./index.js?vue&type=script&lang=js&"
export * from "./index.js?vue&type=script&lang=js&"
import style0 from "./index.less?vue&type=style&index=0&id=db400fb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db400fb2",
  null
  
)

export default component.exports